import { Directive } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- intentional bare attribute name (`openNewTab`, not `appOpenNewTab`) so templates read as plain HTML-ish attributes; deliberate exception, unlike most `[appFoo]`-prefixed directives in this codebase
  selector: 'a[openNewTab]',
  host: {
    target: '_blank',
    rel: 'noopener noreferrer',
  },
})
export class OpenNewTab {}
